import { render, staticRenderFns } from "./ProjectSttSettings.vue?vue&type=template&id=956a2526&scoped=true&"
import script from "./ProjectSttSettings.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProjectSttSettings.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956a2526",
  null
  
)

export default component.exports